(function () {
  var STORAGE_KEY = 'xtrait_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function normalizeButton(button) {
    return {
      id: button.getAttribute('data-product-id') || button.getAttribute('data-product-handle'),
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      vendor: button.getAttribute('data-product-vendor') || '',
      url: button.getAttribute('data-product-url') || '',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || ''
    };
  }

  function isSaved(items, id) {
    return items.some(function (item) { return String(item.id) === String(id); });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  var entryProductCache = {};
  var priceNormalizeTimer = null;
  var priceObserverStarted = false;

  function installFeaturedEdgeFix() {
    if (document.getElementById('x-featured-edge-fix')) return;
    var style = document.createElement('style');
    style.id = 'x-featured-edge-fix';
    style.textContent = [
      'body.is-home .x-featured__row{justify-content:flex-start!important;scroll-padding-inline:var(--gutter,32px)!important;}',
      'body.is-home .x-featured__row .x-featured__card:first-child{margin-left:0!important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function formatMoney(cents) {
    var amount = (parseInt(cents || 0, 10) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '$' + amount;
  }

  function variantPrice(variant) {
    return parseInt(variant && variant.price ? variant.price : 0, 10) || 0;
  }

  function isSampleVariant(variant) {
    var title = String((variant && (variant.public_title || variant.title || variant.name)) || '').toLowerCase();
    var compact = title.replace(/\s+/g, '').replace(/-/g, '');
    return title.indexOf('sample') !== -1 ||
      title.indexOf('discovery') !== -1 ||
      title.indexOf('vial') !== -1 ||
      title.indexOf('decant') !== -1 ||
      title.indexOf('travel') !== -1 ||
      title.indexOf('tester') !== -1 ||
      title.indexOf('mini') !== -1 ||
      compact.indexOf('0.7ml') !== -1 ||
      compact.indexOf('1ml') !== -1 ||
      compact.indexOf('1.5ml') !== -1 ||
      compact.indexOf('2ml') !== -1 ||
      compact.indexOf('3ml') !== -1 ||
      compact.indexOf('5ml') !== -1 ||
      compact.indexOf('10ml') !== -1 ||
      compact.indexOf('15ml') !== -1;
  }

  function lowestVariant(variants) {
    return (variants || []).reduce(function (best, variant) {
      if (!best) return variant;
      return variantPrice(variant) < variantPrice(best) ? variant : best;
    }, null);
  }

  function displayVariantFromProduct(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    var availableBottles = product.variants.filter(function (variant) {
      return variant.available && !isSampleVariant(variant);
    });
    if (availableBottles.length) return lowestVariant(availableBottles);
    var bottles = product.variants.filter(function (variant) { return !isSampleVariant(variant); });
    if (bottles.length) return lowestVariant(bottles);
    var available = product.variants.filter(function (variant) { return variant.available; });
    return lowestVariant(available.length ? available : product.variants);
  }

  function productJsonUrl(card) {
    if (!card) return '';
    var viewLink = card.querySelector('.product-card__view');
    var raw = card.getAttribute('data-product-url') ||
      (viewLink ? viewLink.getAttribute('href') : '') ||
      (card.getAttribute('data-product-handle') ? '/products/' + card.getAttribute('data-product-handle') : '');
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      return url.origin + url.pathname.replace(/\/$/, '') + '.js';
    } catch (err) {
      return raw.split('?')[0].replace(/\/$/, '') + '.js';
    }
  }

  function applyDisplayVariantToCard(card, variant) {
    if (!card || !variant) return;
    var price = variantPrice(variant);
    if (!price) return;
    var variantId = variant.id ? String(variant.id) : '';
    var variantTitle = variant.public_title || variant.title || variant.name || '';
    var available = variant.available !== false;

    card.setAttribute('data-x-price', String(price / 100));
    card.setAttribute('data-x-price-source', 'bottle');
    card.setAttribute('data-x-display-variant-title', variantTitle);
    card.setAttribute('data-x-entry-price-normalized', '1');
    card.setAttribute('data-x-available', available ? 'true' : 'false');
    if (variantId) {
      card.setAttribute('data-variant-id', variantId);
      card.setAttribute('data-product-variant-id', variantId);
    }

    var priceRow = card.querySelector('.price-row');
    if (priceRow) {
      var from = priceRow.querySelector('.from');
      if (from) from.remove();

      var priceEl = priceRow.querySelector('.price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceRow.appendChild(priceEl);
      }
      priceEl.className = 'price';
      priceEl.textContent = formatMoney(price);
    }

    if (variantId) {
      card.querySelectorAll('[data-variant-id], [data-product-variant-id]').forEach(function (node) {
        node.setAttribute('data-variant-id', variantId);
        node.setAttribute('data-product-variant-id', variantId);
      });
      card.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variantId;
      });
    }

    card.querySelectorAll('[data-product-price]').forEach(function (node) {
      node.setAttribute('data-product-price', formatMoney(price));
    });

    var hint = card.querySelector('.product-card__qv-hint');
    if (hint) hint.textContent = available ? 'Quick view' : 'Sold out';
  }

  function hydrateCardEntryPrice(card) {
    if (!card || card.getAttribute('data-x-price-source') === 'bottle' || card.getAttribute('data-x-entry-price-state') === 'loading') return;
    var jsonUrl = productJsonUrl(card);
    if (!jsonUrl) return;
    card.setAttribute('data-x-entry-price-state', 'loading');

    if (!entryProductCache[jsonUrl]) {
      entryProductCache[jsonUrl] = fetch(jsonUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }

    entryProductCache[jsonUrl].then(function (product) {
      var variant = displayVariantFromProduct(product);
      if (variant) {
        applyDisplayVariantToCard(card, variant);
        card.setAttribute('data-x-entry-price-state', 'done');
      } else {
        card.setAttribute('data-x-entry-price-state', 'missing');
      }
      sync();
    }).catch(function () {
      card.setAttribute('data-x-entry-price-state', 'error');
    });
  }

  function normalizeProductCardPrices(scope, maxCards) {
    Array.prototype.slice.call((scope || document).querySelectorAll('.product-card'))
      .filter(function (card) { return card.getAttribute('data-x-price-source') !== 'bottle'; })
      .slice(0, maxCards || 80)
      .forEach(hydrateCardEntryPrice);
  }

  function schedulePriceNormalize(scope) {
    if (priceNormalizeTimer) window.clearTimeout(priceNormalizeTimer);
    priceNormalizeTimer = window.setTimeout(function () {
      normalizeProductCardPrices(scope || document, 80);
    }, 120);
  }

  function initPriceObserver() {
    if (priceObserverStarted || !document.body || !window.MutationObserver) return;
    priceObserverStarted = true;
    new MutationObserver(function (mutations) {
      var hasProductCards = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.product-card')) ||
            (node.querySelector && node.querySelector('.product-card'))
          );
        });
      });
      if (hasProductCards) schedulePriceNormalize(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.XtraitNormalizeProductPrices = normalizeProductCardPrices;

  function syncButtons(items) {
    document.querySelectorAll('[data-x-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id') || button.getAttribute('data-product-handle');
      var active = isSaved(items, id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var title = button.getAttribute('data-product-title') || 'this fragrance';
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + title + (active ? ' from wishlist' : ' to wishlist'));
    });
  }

  function syncCounts(items) {
    document.querySelectorAll('[data-x-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
  }

  function renderDrawer(items) {
    var list = document.querySelector('[data-x-wishlist-list]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML =
        '<div class="x-wishlist__empty">' +
          '<p>No saved bottles yet.</p>' +
          '<a href="/collections/all">Shop fragrance</a>' +
        '</div>';
      return;
    }

    list.innerHTML = items.map(function (item) {
      return (
        '<article class="x-wishlist__item" data-x-wishlist-item="' + escapeHtml(item.id) + '">' +
          '<a class="x-wishlist__media" href="' + escapeHtml(item.url) + '">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '') +
          '</a>' +
          '<div>' +
            '<div class="x-wishlist__vendor">' + escapeHtml(item.vendor) + '</div>' +
            '<a class="x-wishlist__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
            '<div class="x-wishlist__price">' + escapeHtml(item.price) + '</div>' +
          '</div>' +
          '<button type="button" class="x-wishlist__remove" data-x-wishlist-remove="' + escapeHtml(item.id) + '">Remove</button>' +
        '</article>'
      );
    }).join('');
  }

  function sync() {
    var items = read();
    syncButtons(items);
    syncCounts(items);
    renderDrawer(items);
  }

  function initFeaturedFallback(scope) {
    (scope || document).querySelectorAll('[data-x-featured]').forEach(function (section) {
      if (section.dataset.xFeaturedFallbackInit === '1') return;
      section.dataset.xFeaturedFallbackInit = '1';
      var row = section.querySelector('[data-x-featured-row]');
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-x-featured-mode]'));
      if (!row || !buttons.length) return;

      var limit = parseInt(section.getAttribute('data-products-count') || '8', 10);
      var kicker = section.querySelector('[data-x-featured-kicker]');
      var titleMain = section.querySelector('[data-x-featured-title-main]');
      var titleItalic = section.querySelector('[data-x-featured-title-italic]');
      var lede = section.querySelector('[data-x-featured-lede]');
      var link = section.querySelector('[data-x-featured-link]');
      var modesEl = section.querySelector('[data-x-featured-modes]');
      var prevButton = section.querySelector('[data-x-featured-prev]');
      var nextButton = section.querySelector('[data-x-featured-next]');
      var arrowFrame = null;
      var loadId = 0;
      var modes = [
        {
          key: 'current',
          html: row.innerHTML,
          loaded: true,
          kicker: kicker ? kicker.textContent.trim() : '',
          titleMain: titleMain ? titleMain.textContent.trim() : 'The current',
          titleItalic: titleItalic ? titleItalic.textContent.trim() : 'edit.',
          lede: lede ? lede.textContent.trim() : '',
          linkText: link ? link.textContent.trim() : 'Shop all fragrance →',
          linkHref: link ? link.getAttribute('href') : '/collections/all'
        },
        {
          key: 'best',
          url: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling',
          kicker: 'Best sellers',
          titleMain: 'Best',
          titleItalic: 'sellers.',
          lede: 'The bottles shoppers keep coming back for right now.',
          linkText: 'Shop best sellers →',
          linkHref: section.getAttribute('data-best-url') || '/collections/all?sort_by=best-selling'
        },
        {
          key: 'newest',
          url: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending',
          kicker: 'Newest additions',
          titleMain: 'Newest',
          titleItalic: 'additions.',
          lede: 'Fresh arrivals just added to the shelf.',
          linkText: 'Shop new arrivals →',
          linkHref: section.getAttribute('data-newest-url') || '/collections/all?sort_by=created-descending'
        }
      ];

      function htmlFromCollection(markup) {
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var seen = {};
        return Array.prototype.slice.call(doc.querySelectorAll('.product-card')).filter(function (card) {
          var id = card.getAttribute('data-product-id') || card.getAttribute('data-product-handle') || card.textContent.trim();
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        }).slice(0, limit).map(function (card) {
          card.querySelectorAll('script').forEach(function (script) { script.remove(); });
          return '<div class="x-featured__card">' + card.outerHTML + '</div>';
        }).join('');
      }

      function loadMode(mode) {
        if (mode.loaded) return Promise.resolve(mode.html);
        return fetch(mode.url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (markup) {
            var html = markup ? htmlFromCollection(markup) : '';
            mode.html = html || modes[0].html;
            mode.loaded = true;
            return mode.html;
          })
          .catch(function () { return modes[0].html; });
      }

      function cardStep() {
        var card = row.querySelector('.x-featured__card');
        var styles = getComputedStyle(row);
        var gap = parseFloat(styles.columnGap || styles.gap) || 24;
        return card ? card.getBoundingClientRect().width + gap : row.clientWidth * 0.5;
      }

      function updateArrows() {
        arrowFrame = null;
        if (!prevButton || !nextButton) return;
        var max = Math.max(0, row.scrollWidth - row.clientWidth);
        var left = row.scrollLeft;
        prevButton.disabled = left <= 4;
        nextButton.disabled = max <= 4 || left >= max - 4;
      }

      function queueArrowUpdate() {
        if (arrowFrame) return;
        arrowFrame = window.requestAnimationFrame(updateArrows);
      }

      function initManualArrows() {
        if (!prevButton || !nextButton || section.dataset.xFeaturedManualArrowsInit === '1') return;
        section.dataset.xFeaturedManualArrowsInit = '1';
        prevButton.addEventListener('click', function () {
          row.scrollBy({ left: -1 * cardStep() * (window.matchMedia('(min-width: 961px)').matches ? 2 : 1), behavior: 'smooth' });
          window.setTimeout(queueArrowUpdate, 260);
        });
        nextButton.addEventListener('click', function () {
          row.scrollBy({ left: cardStep() * (window.matchMedia('(min-width: 961px)').matches ? 2 : 1), behavior: 'smooth' });
          window.setTimeout(queueArrowUpdate, 260);
        });
        row.addEventListener('scroll', queueArrowUpdate, { passive: true });
        window.addEventListener('resize', queueArrowUpdate, { passive: true });
        updateArrows();
      }

      function setMode(key) {
        var mode = modes.filter(function (item) { return item.key === key; })[0] || modes[0];
        var thisLoad = ++loadId;
        if (kicker) kicker.textContent = mode.kicker;
        if (titleMain) titleMain.textContent = mode.titleMain;
        if (titleItalic) titleItalic.textContent = mode.titleItalic;
        if (lede) lede.textContent = mode.lede;
        if (link) {
          link.textContent = mode.linkText;
          link.setAttribute('href', mode.linkHref);
        }
        if (modesEl) modesEl.setAttribute('data-active', mode.key);
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-x-featured-mode') === mode.key;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        row.classList.add('is-refreshing');
        loadMode(mode).then(function (html) {
          if (thisLoad !== loadId) return;
          row.innerHTML = html;
          row.scrollTo({ left: 0, behavior: 'auto' });
          row.classList.remove('is-refreshing');
          normalizeProductCardPrices(row, limit);
          updateArrows();
          sync();
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.getAttribute('data-x-featured-mode'));
        });
      });

      normalizeProductCardPrices(row, limit);
      initManualArrows();
    });
  }

  function hydrateCachedHomeSections() {
    if (window.__xtraitHomeHydrated) return;
    var isHome = document.body && document.body.classList.contains('is-home');
    if (!isHome && window.location.pathname !== '/') return;
    var isStale = document.querySelector('.x-moods__tabs, [data-x-mood-mode]') || !document.querySelector('[data-x-featured-mode]');
    if (!isStale) {
      initFeaturedFallback(document);
      return;
    }

    var sectionIds = [];
    ['featured', 'moods'].forEach(function (suffix) {
      var node = document.querySelector('[id^="shopify-section-template--"][id$="__' + suffix + '"]');
      if (node && node.id) sectionIds.push(node.id.replace(/^shopify-section-/, ''));
    });
    if (!sectionIds.length) return;
    window.__xtraitHomeHydrated = true;

    fetch('/?sections=' + sectionIds.join(','), { credentials: 'same-origin', headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        sectionIds.forEach(function (id) {
          if (!sections[id]) return;
          var target = document.getElementById('shopify-section-' + id);
          if (!target) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = sections[id];
          var fresh = tmp.firstElementChild;
          if (fresh) target.replaceWith(fresh);
        });
        initFeaturedFallback(document);
        normalizeProductCardPrices(document, 80);
        sync();
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-x-wishlist-drawer]');
    var scrim = document.querySelector('.x-wishlist-scrim');
    if (!drawer) return;
    drawer.setAttribute('open', '');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('is-wishlist-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-x-wishlist-drawer]');
    var scrim = document.querySelector('.x-wishlist-scrim');
    if (!drawer) return;
    drawer.removeAttribute('open');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('is-wishlist-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-x-open-wishlist]');
    if (open) {
      event.preventDefault();
      sync();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-x-close-wishlist]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = event.target.closest('[data-x-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      var removeId = remove.getAttribute('data-x-wishlist-remove');
      write(read().filter(function (item) { return String(item.id) !== String(removeId); }));
      sync();
      return;
    }

    var button = event.target.closest('[data-x-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var item = normalizeButton(button);
    if (!item.id) return;

    var items = read();
    if (isSaved(items, item.id)) {
      items = items.filter(function (saved) { return String(saved.id) !== String(item.id); });
    } else {
      items.unshift(item);
    }
    write(items);
    sync();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('xtrait:wishlist:sync', sync);
  document.addEventListener('DOMContentLoaded', function () {
    installFeaturedEdgeFix();
    sync();
    hydrateCachedHomeSections();
    initPriceObserver();
    normalizeProductCardPrices(document, 80);
  });
  document.addEventListener('shopify:section:load', function () {
    installFeaturedEdgeFix();
    sync();
    initFeaturedFallback(document);
    initPriceObserver();
    normalizeProductCardPrices(document, 80);
  });

  installFeaturedEdgeFix();
})();
